angular.module('elfium').controller('dashboardSumPanelController', ['$scope',
    function ($scope) {
        var that = this;
        $scope.getHeaderClass = function () {
            return 'list-group-item-' + $scope.type;
        };
        $scope.getTextClass = function () {
            return 'text-' + $scope.headerClass;
        };
        $scope.getPercentage = function () {
            var percentage = 0;
            if ($scope.expectedSum) {
                percentage = ($scope.currentSum / $scope.expectedSum) * 100;
            }
            return percentage;
        };
        
    }
]); 


// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboardTotalItemController.ts